import React, { Component } from 'react';

export default OriginalComponent =>
	class WrapperComponent extends Component {
		constructor(props) {
			super(props);
		}

		render() {
			const { onAction } = this.props;

			return (
				<div className="section__editable">
					<div className="block__actions for-admin">
						<div className="block__actions_border"></div>
						<div className="block__actions_btns">
							<button
								onClick={() => onAction('up')}
								className="block__actions--up"
							></button>
							<button
								onClick={() => onAction('down')}
								className="block__actions--down"
							></button>
							<button
								onClick={() => onAction('edit')}
								className="block__actions--edit"
							></button>
							<button
								onClick={() => onAction('del')}
								className="block__actions--del"
							></button>
						</div>
					</div>
					<OriginalComponent {...this.props} />
				</div>
			);
		}
	};
